/**
 * Convenience method to obtain a className for components.
 * There are 4 possible scenarios:
 * - Finds and returns the requested "className".
 * - Returns the "defaultValue" when "className" is falsy.
 * - Returns "unknown" (a.k.a red dotted border) if "className" is specified but NOT found in "styles".
 * - Throws an error if invalid arguments are passed.
 * @param {Object} styles - The style imported from CSS Modules.
 * @param {String} className - The className of the style to get.
 * @param {String} defaultValue - The defaultValue to return if className is falsy.
 * @throws {Error} Invalid arguments.
 * @returns {String} className
 */
export const getClassName = (styles = {}, className = '', defaultValue = '') => {
    // className is falsy, return the defaultValue
    if (!className) {
        return defaultValue;
    }

    // find the requested className
    const classNameFound = styles[className];

    // className not found
    if (!classNameFound) {
        return 'undefined';
    }

    // invalid className found in the styles object
    if (typeof classNameFound !== 'string') {
        throw new Error(`Invalid className found in styles object: ${JSON.stringify(classNameFound)}`);
    }

    // we found the className
    return classNameFound;
};
